import React, { useState } from "react";
import {
  Typography,
  Box,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { KickOffPlaySelection } from "./KickOffPlaySelection";
import { KickOffLog } from "./KickOffLog";
import { KickOffTackleLog } from "./KickOffTackleLog";
import { KickOffPenaltyLog } from "./KickOffPenaltyLog";


export const KickOffLogger = () => {
  const [expandedAccordion, setExpandedAccordion] = useState<string | false>(
    "play-selection"
  );

  const handleAccordionChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpandedAccordion(isExpanded ? panel : false);
    };

  return (
    <Paper elevation={3} sx={{ p: 1, margin: "0 auto", maxWidth: 1140 }}>
      <Box>
        <Accordion
          expanded={expandedAccordion === "play-selection"}
          onChange={handleAccordionChange("play-selection")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="play-selection-content"
            id="play-selection-header"
          >
            <Typography>Play Selection</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <KickOffPlaySelection />
          </AccordionDetails>
        </Accordion>

        <Accordion
          expanded={expandedAccordion === "kickoff-log"}
          onChange={handleAccordionChange("kickoff-log")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="kickoff-log-content"
            id="kickoff-log-header"
          >
            <Typography>Kickoff Log</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <KickOffLog />
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expandedAccordion === "tackle-log"}
          onChange={handleAccordionChange("tackle-log")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="tackle-log-content"
            id="tackle-log-header"
          >
            <Typography>Tackle Log</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <KickOffTackleLog />
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expandedAccordion === "penalty-log"}
          onChange={handleAccordionChange("penalty-log")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="penalty-log-content"
            id="penalty-log-header"
          >
            <Typography>Penalty Log</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <KickOffPenaltyLog />
          </AccordionDetails>
        </Accordion>
      </Box>
    </Paper>
  );
};
